import fetch from '@/utils/fetch';

// 获取地区信息
export function getArea(pid = 0) {
  let _areaUri = '/api/v1/areas';
  if (pid) _areaUri += '/' + pid;

  return fetch({
    url: _areaUri,
    method: 'get',
  })
}

// 获取返货地区信息
export function getDeliveries() {
  return fetch({
    url: '/shop/v1/delivery_areas',
    method: 'get'
  })
}

// 新增发货模版
export function createDelivery(data) {
  return fetch({
    url: '/shop/v1/delivery_areas',
    data,
    method: 'post'
  })
}

// 更新发货模版
export function updateDelivery(id, data) {
  return fetch({
    url: `/shop/v1/delivery_areas/${id}`,
    data,
    method: 'put'
  })
}
